import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import "../../../Assets/css/card.css";
// import loaderGif from '../../../Assets/img/icons/Animation - 1718370478484.gif'
import { useQuantityContext } from '../../QuantityContext';
// import DefaultLogo from "../../../Assets/img/default-logo.png";
import DefaultProfileBg from "../../../Assets/img/card/profilebg.png"
import { useUserDetailContext } from '../../UserDetailContext';
import { useCreateCardDetailContext } from '../../CreatecardDetailContext';
import lock_symbol from "../../../Assets/img/lock-symbol.png"
import { Dialog, DialogTitle, DialogContent, DialogContentText, IconButton, Box } from "@mui/material";
import PersonIcon from '@mui/icons-material/Person';
import { ReactComponent as FamilyIcon } from '../../../Assets/img/icons/Family.svg'
import { ReactComponent as FriendsIcon } from '../../../Assets/img/icons/friends_iconGroup.svg'
import { ReactComponent as ProfessionalIcon } from '../../../Assets/img/icons/Professional-icon.svg'
import { ReactComponent as GenzIcon } from '../../../Assets/img/icons/Genz-icon.svg'
import EventIcon from '@mui/icons-material/Event';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { AllCardLayouts } from './Layouts2';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { ReactComponent as PersonalCardIcon } from '../../../Assets/img/icons/card Personal customize.svg'
import { ReactComponent as StudentIcon } from '../../../Assets/img/icons/Student.svg'
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import LightBoxGroupCreate from './GroupCard/LightBoxGroupCreate';
import { Link } from "react-router-dom";
import { motion } from 'framer-motion';
import AllCardsSkeleton from '../../LoadingSkeleton/AllCardsSkeleton';
import { useSelector } from 'react-redux';

const AllCards = () => {
    const navigate = useNavigate();
    const apiKey = process.env.REACT_APP_API_KEY;
    const { quantity, sortOrder, sortDateOrder, latestDateOrder } = useQuantityContext();
    const { setOtherCards, setCards, setGroupCardDetails, cards, userDetails, favoriteCards, setFavoriteCards, groupCardDetails } = useUserDetailContext();

    const { setCardDetails, setCardStyles, setCardQrStyles, setContactStyles, setSocialLinks, setAttachDocs,
        setIsPersonalDetailsSaved, updateCardDetails, updateSocialLinks2, updateCardStyles, updateCardQrStyles, updateContactStyles, updateAttachDocsVal } = useCreateCardDetailContext();
    const objectId = localStorage.getItem("objectId");


    const Allcards = useSelector((state) => state?.CardArray?.AllCardDetailsInfo);
    // console.log("AllCardsAllCards", Allcards);
    const cardDetailsAll = useSelector((state) => state?.CardArray?.AllCardsInfo?.Details);

    const cardStylesAll = useSelector((state) => state?.CardArray?.AllCardsInfo?.CardDesigns);

    const AllcardContactInfo = useSelector((state) => state?.CardArray?.AllCardsInfo?.CardContacts);

    // console.log("groupCardDetailsgroupCardDetails", AllcardContactInfo);
    axios.defaults.baseURL = `${process.env.REACT_APP_BACKEND_URL}`;
    const [isVerifiedDialogOpen, setIsVerifiedDialogOpen] = useState(false);
    const [OpenLightBoxForCategory, setOpenLightBoxForCategory] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [NewCardType, setNewCardType] = useState('');
    const [chooseCategory, setchooseCategory] = useState(false);
    const [chooseCustomizeCategory, setChooseCustomizeCategory] = useState(false);
    const [chooseCategoryForGroup, setChooseCategoryGroup] = useState(false);

    const [familyCardCreate, setFamilyCardCreate] = useState(false);
    const [loading, setLoading] = useState(true);
    const [pendingRequests, setPendingRequests] = useState(0);

    const cardVariants = {
        hidden: { opacity: 0, y: 50 },
        visible: { opacity: 1, y: 0 },
        exit: { opacity: 0, y: 50 },
    };

    //react-framer-motion
    const [isVisible, setIsVisible] = useState(false);
    useEffect(() => {
        const timer = setTimeout(() => {
            setIsVisible(true); // Set to true after a delay to trigger animation
        }, 100); // You can adjust this timeout as necessary
        return () => clearTimeout(timer);
    }, []);

    const handleCategoryClick = (category) => {
        setSelectedCategory(category);
        setOpenLightBoxForCategory(false);
        setchooseCategory(true);
    };

    const handleCardTypeClick = (category) => {
        // console.log("Category :", category);
        setNewCardType(category);
        updateCardDetails({ "CardType": category });
        updateCardStyles({ "CardType": category });
        if (category === "Customize_Personal") {
            updateCardStyles({ "layoutStyle": '2' }); //For Personal Card - Default Layout is 2
        }
        updateCardQrStyles({ "CardType": category });
        updateSocialLinks2({ "card_type": category });
        updateContactStyles({ "card_type": category, mobile_number: userDetails.phone, email: userDetails.email });
        updateAttachDocsVal({ fieldName: "card_name", value: category }); // It is Needed If CardType is GenZ itself
        setchooseCategory(false);
        setChooseCustomizeCategory(false);
        setIsPersonalDetailsSaved(false);
        navigate('/create-card', { state: { category: category } });
    }

    const handleIntialContext = () => {
        setCardDetails({
            User_ID: objectId,
            CardType: "Personal",
            CardName: '',
            employee_id: '',
            company_id: '',
            profession_department: '',
            profession_id: '',
            company_website: '',
            is_professional_verified: false,
            professional_details_status: '',
            student_id: '',
            student_email_id: '',
            student_year: '',
            student_ending_year: '',
            student_currently_pursuing: false,
            education_level: '',
            institute: '',
            board: '',
            degree: '',
            field_of_study: '',
            grade: '',
            is_student_verified: false,
            student_details_status: '',
            prefix: '',
            suffix: '',
            title: '',
            nickname: '',
            summary: '',
            designation: '',
            company: '',
            profession_department: '',
            professional_email_id: '',
            profile_pic: '',
            logo: '',
            additionalFields: {}
        });

        setCardStyles({
            User_ID: objectId,
            CardType: "Personal",
            CardName: '',
            font: '',
            size: '',
            style: '',
            colorPrimary: '',
            colorSecondary: '',
            colorTitle: '',
            colorLayout: '#0044c6',
            bgColor: '#ffffff',
            imageExtract: null,
            layoutStyle: '1'
        });

        setCardQrStyles({
            User_ID: objectId,
            CardType: "Personal",
            CardName: '',
            eyeBall: '',
            eyeBallcolor: '',
            eyeFrame: '',
            eyeFrameColor: '',
            qrPattern: '',
            qrPatterncolor: '#121212',
            border: '',
            bordercolor: '',
            addbg: '',
            addbgcolor: '#ede8e8'
        });

        setContactStyles({
            card_type: "Personal",
            CardName: '',
            reference_id: objectId,
            location: '',
            mobile_number: '',
            call_visible: true,
            sms_visible: true,
            email: '',
            email_visible: true,
            whatsapp: '',
            whatsapp_visible: true,
            address: '',
            state: '',
            postal_code: '',
            city: '',
            country: '',
            is_public: true,
        });

        setSocialLinks({
            user_ref_id: "",
            card_type: "Personal",
            CardName: '',
            links: [
                { network: 'linkedin', url: '', visible: true },
                { network: 'facebook', url: '', visible: true },
                { network: 'instagram', url: '', visible: true },
            ],
        });

        setAttachDocs({
            user_ref_id: "",
            card_id: null,
            card_name: "",
            images: [],
            videos: [],
            others: []
        });
    }

    //LightBox Function Handling for an Group Cards
    const handleCloseVerifiedDialog = () => {
        setIsVerifiedDialogOpen(false);
        setOpenLightBoxForCategory(false);
        setchooseCategory(false);
        setChooseCustomizeCategory(false);
    };

    const handleCreateNewCard = () => {
        // if (displayProf || displayStud) {
        //     setIsVerifiedDialogOpen(true);
        // }
        // else {
        setSelectedCategory('');
        setNewCardType('');
        setOpenLightBoxForCategory(true);
        // }
    }
    const todayDate = new Date();

    useEffect(() => {
        if (sortOrder !== null) {
            const sortedCards = [...Allcards]?.sort((a, b) => {
                if (sortOrder === 'ascending') {
                    return a.card_name.localeCompare(b.card_name);
                } else {
                    return b.card_name.localeCompare(a.card_name);
                }
            });
            setOtherCards(sortedCards);
        }
    }, [sortOrder]);

    useEffect(() => {
        if (sortDateOrder !== null) {
            const sortedCards = [...Allcards]?.sort((a, b) => {
                const dateA = new Date(a.created_at);
                const dateB = new Date(b.created_at);

                return sortDateOrder === 'ascending' ? dateA - dateB : dateB - dateA;
            });

            setOtherCards(sortedCards);
        }
    }, [sortDateOrder]);

    useEffect(() => {
        if (latestDateOrder !== null) {
            const sortedCards = [...Allcards]?.sort((a, b) => {
                const dateA = new Date(a.modified_at);
                const dateB = new Date(b.modified_at);

                if (latestDateOrder === 'latestDate') {
                    return dateB - dateA; // Latest date first
                } else {
                    return dateA - dateB; // Earliest date first
                }
            });

            setOtherCards(sortedCards);
        }
    }, [latestDateOrder]);

    const [ContactStylesForGenZ, setContactStylesForGenZ] = useState({
        User_ID: objectId,
        CardType: 'GenZ',
        callNo: { input: `${userDetails.phone}`, visible: true },
        textNo: { input: `${userDetails.phone}`, visible: true },
        emailId: { input: `${userDetails.email}`, visible: true },
        whatsapp: { input: `${userDetails.phone}`, visible: true },
    });

    const headers = {
        'x-api-key': apiKey,
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${objectId}`
    };

    const updateFavoriteCards = async (User_ID, cardName, isFavorite) => {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/card/updateCardFavourite`,
                { User_ID, card_name: cardName, is_favourite: isFavorite },
                {
                    headers: headers
                }
            );
            console.log('Updated favorite card:', response.data);
        } catch (error) {
            console.error('Error updating favorite card:', error.response.data.message);
        } finally {
            setPendingRequests((prev) => prev - 1);
        }
    };


    const handleFavoriteClick = async (card) => {
        const isFavorite = favoriteCards.includes(card);
        // Update the favorite cards state
        setFavoriteCards((prevFavorites) => {
            if (prevFavorites.includes(card)) {
                // If the card is already in favorites, remove it
                return prevFavorites.filter(favCard => favCard !== card);
            } else {
                // Otherwise, add it to the favorites
                return [...prevFavorites, card];
            }
        });

        const User_ID = objectId.trim();
        await updateFavoriteCards(User_ID, card, !isFavorite); // dont change the logic of isFavourite
    };

    const getFontWeight = (style) => {
        switch (style) {
            case 'Light':
                return 300; // Font weight for Light
            case 'Regular':
                return 500; // Font weight for Regular
            case 'Medium':
                return 600; // Font weight for Medium
            case 'Semi Bold':
                return 700; // Font weight for Semi Bold
            case 'Bold':
                return 800; // Font weight for Bold
            default:
                return 'normal'; // Default font weight
        }
    };

    const initialDialogsState = cards.reduce((acc, card) => {
        acc[card] = false;
        return acc;
    }, {});

    const [dialogs, setDialogs] = useState({
        initialDialogsState
    });

    const handleOpenDialog = (type) => {
        setDialogs((prevDialogs) => ({
            ...prevDialogs,
            [type]: true
        }));
    };

    const handleCloseDialog = (type) => {
        setDialogs((prevDialogs) => ({
            ...prevDialogs,
            [type]: false
        }));
    };

    const [sharePops, setSharePops] = useState({
        initialDialogsState
    });
    // console.log("allCardsallCards", cardDetailsAll)

    const handleShareClick = (type) => {
        setSharePops((prevDialogs) => ({
            ...prevDialogs,
            [type]: true
        }));
    };

    const handleShareClose = (type) => {
        setSharePops((prevDialogs) => ({
            ...prevDialogs,
            [type]: false
        }));
    };


    useEffect(() => {
        if (Allcards?.length > 0 && pendingRequests === 0) {
            setLoading(false);
        }
    }, [Allcards, pendingRequests]);


    if (loading) {
        return (
            <AllCardsSkeleton />
        );
    }

    // console.log("ALL CARDS INSIDE THE CARDS PAGE", AllCards);
    //based on ncard name only saving and Fetching
    const createLayoutProps = (cardName) => {
        // console.log("cardName cardName", cardName);
        const CardDetailsFilterByName = cardDetailsAll?.find((state) => state?.CardName === cardName);
        const CardDeailsForStyles = cardStylesAll?.find((state) => state?.CardName === cardName);
        const cardContactData = AllcardContactInfo?.find((state) => state?.CardName === cardName);
        const styles = CardDeailsForStyles;
        const details = CardDetailsFilterByName;
        // const layoutStyle = styles.map((card) => card.layoutStyle);

        // console.log("LAYOUTS", cardContactData);

        return {
            profilePicture: details?.profile_pic || DefaultProfileBg,
            companyLogo: details?.logo || DefaultProfileBg,
            cardName,
            prefix: details?.prefix || '',
            suffix: details?.suffix || '',
            firstName: details?.firstName || '',
            lastName: details?.lastName || '',
            companyName: details?.company || '',
            designation: details?.designation || '',
            title: details?.title || '',
            colorPrimary: styles?.colorPrimary,
            colorSecondary: styles?.colorSecondary,
            colorTitle: styles?.colorTitle,
            bgColor: styles?.bgColor || "#ffff",
            layoutColor: styles?.colorLayout || "#0044C6B8",
            labelColor: '#ffffff',
            style: styles?.style || "Lato",
            phoneNo: userDetails?.phone,
            emailId: userDetails?.email,
            isVerified: details?.is_professional_verified || false,
            is_student_verified: details?.is_student_verified || false,
            quantity: quantity,
            CardStylesofCard: styles,
            sharePops: sharePops,
            cardDetailsofCard: details,
            handleFavoriteClick: handleFavoriteClick,
            userDetails: userDetails,
            ContactStylesofCard: ContactStylesForGenZ,
            dialogs: dialogs,
            handleCloseDialog: handleCloseDialog,
            handleShareClose: handleShareClose,
            getFontWeight: getFontWeight,
            handleOpenDialog: handleOpenDialog,
            handleShareClick: handleShareClick,
            contactDetails: cardContactData
        };
    };

    // console.log("ALL CARDS STYLES", cardStylesAll);
    const layoutStyleAll = (cardType, cardName) => {
        let currentLayout = cardStylesAll?.find((card) => card.CardName === cardName);
        // console.log("current LAYOut", currentLayout);

        // if (!currentLayout) {
        //     console.warn(`No layout found for cardType: ${cardType}`);


        //     const initialCardStyles = {
        //         User_ID: objectId,
        //         CardType: cardType,
        //         CardName: cardName,
        //         font: '',
        //         size: '',
        //         style: '',
        //         colorPrimary: '',
        //         colorSecondary: '',
        //         colorTitle: '',
        //         colorLayout: '#0044c6',
        //         bgColor: '#ffff',
        //         layoutStyle: (cardType === 'Personal' || cardType === 'Customize_Personal') ? '2' : '1',
        //     };


        //     return currentLayout.layoutStyle; // Return a default value or null to indicate no layout was found
        // } else {
        //     if (cardType === "Customize_Personal" || cardType === "Personal") {
        //         console.log(`current log is ${cardName}`, currentLayout.layoutStyle);
        //         return currentLayout.layoutStyle || '2';
        //     }
        //     return currentLayout.layoutStyle || '1';
        // }


        if (!currentLayout) {
            // console.warn(`No layout found for cardType: ${cardType}`);

            const initialCardStyles = {
                User_ID: objectId,
                CardType: cardType,
                CardName: cardName,
                font: '',
                size: '',
                style: '',
                colorPrimary: '',
                colorSecondary: '',
                colorTitle: '',
                colorLayout: '#0044c6',
                bgColor: '#ffff',
                layoutStyle: (cardType === 'Personal' || cardType === 'Customize_Personal') ? '2' : '1',
            };

            // Update the currentLayout with initialCardStyles
            currentLayout = initialCardStyles;
            if (cardType === "Customize_Personal" || cardType === "Personal") {
                console.log(`current log is ${cardName}`, currentLayout?.layoutStyle);
                return currentLayout?.layoutStyle || '2';
            }
            return currentLayout?.layoutStyle || '1';
            // Return the layoutStyle value from the updated currentLayout
        } else {
            if (cardType === "Customize_Personal" || cardType === "Personal") {
                console.log(`current log is ${cardName}`, currentLayout?.layoutStyle);
                return currentLayout?.layoutStyle || '2';
            }
            return currentLayout?.layoutStyle || '1';
        }


    };


    const filteredGroupCards = Allcards?.filter((card) => card?.card_type === "group_family" && card?.card_email !== null);

    return (
        <div className='Allcards_full_container'>
            <div className="container-card-display">
                <motion.div
                    className="items-container-card"
                    variants={cardVariants}
                    initial="hidden"
                    animate={isVisible ? "visible" : "hidden"}>

                    {/* {Allcards?.filter((card) => card?.card_type !== "GenZ" && card?.card_type !== "group_family")?.map((card, index) => {
                        const layoutStyle = layoutStyleAll(card?.card_type, card?.card_name);
                        // console.log(`CARD TYPE${card.card_type} and CARD NAME ${card.card_name} AND LAYOUT IS ${layoutStyle}`);
                        if (['1', '2', '3', '4', '5', '6', '7', '8'].includes(layoutStyle)) {
                            return (
                                // <div key={card.card_name}>
                                <motion.div
                                    key={card?.card_name}
                                    initial="hidden"
                                    animate="visible"
                                    exit="exit"
                                    variants={cardVariants}
                                    transition={{
                                        delay: index * 0.1, // Delay each card slightly for a staggered effect
                                        duration: 0.5,
                                    }}
                                >
                                    {AllCardLayouts(layoutStyle, createLayoutProps(card?.card_name), card?.card_name)}
                                </motion.div>
                                // </div>
                            );
                        }
                    })} */}

                    {Allcards?.filter((card) => card?.card_type !== "GenZ" && card?.card_type !== "group_family")
                        ?.map((card, index) => {
                            const layoutStyle = layoutStyleAll(card?.card_type, card?.card_name);
                            // console.log(`Card ID: ${card.id}, Name: ${card.card_name}, Layout: ${layoutStyle}`);
                            let adjustedLayoutStyle = layoutStyle;

                            if (['hr2', 'hr1', 'ca1', 'ca2', 'bk1', 'bk2', 'fl1', 'fl2', 'cs1', 'cs2', 'it1', 'it2', 'adv1', 'adv2', 'dr1', 'dr2'].includes(layoutStyle)) {
                                adjustedLayoutStyle = '1'
                            }
                            return (
                                <motion.div
                                    key={card?.id}  // Use unique ID
                                    initial="hidden"
                                    animate="visible"
                                    exit="exit"
                                    variants={cardVariants}
                                    transition={{
                                        delay: index * 0.1,
                                        duration: 0.5,
                                    }}
                                >
                                    {AllCardLayouts(adjustedLayoutStyle, createLayoutProps(card?.card_name), card?.card_name)}
                                </motion.div>
                            );
                            // Don't render if layoutStyle doesn't match
                        })}


                    {Allcards?.filter((card, index) => card?.card_type === "group_family" && card?.group_id !== null)?.map((groupCard, index) => (
                        <motion.div
                            key={groupCard?.group_id}
                            initial="hidden"
                            animate="visible"
                            exit="exit"
                            variants={cardVariants}
                            transition={{
                                delay: index * 0.1, // Delay each card slightly for a staggered effect
                                duration: 0.6,
                            }}
                        >
                            <Link to={`/familyCard/${groupCard?.group_id}`} key={groupCard?.group_id}>
                                <div className={`item-card-display digi-card-new ${quantity === 1 ? "Smaller-screen" : ""}`}>
                                    <Box className="preview-card all-cards">
                                        <div id='Card-firstPart-createNew'>
                                            <div className={`preview-card-upper-groupCard ${quantity === 1 ? "Smaller-screen" : ""}`}
                                                style={{
                                                    backgroundImage: `url(${groupCard?.group_image})`,
                                                    backgroundSize: "cover",
                                                    backgroundPosition: "center"
                                                }}>
                                                <div className={`digi-card-label-container truncate ${quantity === 1 ? "Smaller-screen" : ""}`}>
                                                    <span className='digi-card-label'>{groupCard?.card_name}</span>
                                                </div>
                                            </div>

                                            <div className={`preview-card-names text-start ${quantity === 1 ? "Smaller-screen" : ""}`}>
                                                <h3 className='truncate' title={groupCard?.group_subname}>
                                                    {userDetails?.name}
                                                </h3>
                                                <p className='group-card-desc truncate'>
                                                    {groupCard?.group_desc}
                                                </p>
                                            </div>
                                        </div>
                                    </Box>
                                </div>
                            </Link>
                        </motion.div>
                    ))}
                </motion.div>

                <Box className="floating-dropdown-contacts" sx={{ position: 'relative', zIndex: 1, height: '100vh' }}>
                    <Fab color="primary" aria-label="add" onClick={handleCreateNewCard}
                        sx={{ position: 'fixed', bottom: 50, right: 50 }}>
                        <AddIcon />
                    </Fab>
                </Box>
                <Dialog
                    open={isVerifiedDialogOpen}
                    onClose={handleCloseVerifiedDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogContent className="flex-center flex-column">
                        <button style={{ cursor: 'pointer' }} className="lightbox-close" onClick={handleCloseVerifiedDialog}>×</button>
                        <img
                            src={lock_symbol}
                            alt="Verification"
                            className="dialogImage-New-cards"
                        />
                        <DialogTitle id="alert-dialog-title">
                            Need more cards?
                        </DialogTitle>
                        <DialogContentText className="dialogText">
                            A digital card for every need
                            Upgrade to a Premise Account for a more powerful experience
                        </DialogContentText>
                        <DialogContentText className="dialogText mt-2">

                            <div className="d-flex">
                                <button className='mx-2 color-code'>VIEW PLANS</button>
                                <button className='mx-2 newbuttonUpgrade'>UPGRADE</button>
                            </div>
                        </DialogContentText>
                    </DialogContent>
                </Dialog>
                {OpenLightBoxForCategory &&
                    <>
                        <div className="lightbox-overlay">
                            <div className="lightbox-content">
                                <>
                                    <div className='d-flex justify-content-between'>
                                        <h6 className='heading-fav text-left mt-2 mb-0 ms-2'>Create a Card for</h6>
                                        {/* <button style={{ cursor: 'pointer' }} className="lightbox-close2" onClick={handleCloseVerifiedDialog}>×</button> */}
                                        <IconButton onClick={handleCloseVerifiedDialog}>
                                            <CloseRoundedIcon />
                                        </IconButton>
                                    </div>

                                    <div className="mt-2 selectedOptions d-flex justify-content-around">
                                        <div
                                            className={`mx-2 CardCategory flex-center flex-column ${selectedCategory === 'Myself' ? 'selected' : ''}`}
                                            onClick={() => { handleCategoryClick('Myself'); handleIntialContext(); }}
                                        >
                                            <div className="icon-outside-new"><PersonIcon /></div>
                                            <div className="myself">Myself</div>
                                        </div>
                                        {/* <div
                                            className={`mx-2 CardCategory flex-center flex-column ${selectedCategory === 'Family' ? 'selected' : ''}`}
                                            onClick={() => handleCategoryClick('Family')}
                                        > */}
                                        <div className="mx-2 CardCategory flex-center flex-column"
                                            onClick={() => { setChooseCategoryGroup(true); handleCloseVerifiedDialog(); }}>

                                            <div className="icon-outside-new"><FamilyIcon /></div>
                                            <div className="myself">Group</div>
                                        </div>
                                        {/* <div
                                            className={`mx-2 CardCategory flex-center flex-column ${selectedCategory === 'Event' ? 'selected' : ''}`}
                                            onClick={() => handleCategoryClick('Event')}
                                        > */}
                                        <div className="mx-2 CardCategory flex-center flex-column">
                                            <div className="icon-outside-new"><EventIcon /></div>
                                            <div className="myself">Event</div>
                                        </div>
                                    </div>
                                </>
                            </div>
                        </div>
                    </>
                }

                {chooseCategory &&
                    <>
                        <>
                            <div className="lightbox-overlay">
                                <div className="lightbox-content">
                                    <>
                                        <div className='d-flex align-items-center justify-content-between'>
                                            <div className='d-flex align-items-center'>
                                                <IconButton onClick={() => { setchooseCategory(false); setOpenLightBoxForCategory(true); }}>
                                                    <ArrowBackIcon />
                                                </IconButton>
                                                <h6 className='heading-fav text-left mb-0 ms-1'>
                                                    Choose Category</h6>
                                            </div>
                                            {/* <button style={{ cursor: 'pointer' }} className="lightbox-close2" onClick={handleCloseVerifiedDialog}>×</button> */}
                                            <IconButton onClick={handleCloseVerifiedDialog} sx={{ margin: 0, padding: 0 }}>
                                                <CloseRoundedIcon />
                                            </IconButton>
                                        </div>

                                        <div className="mt-2 selectedOptions d-flex align-items-center justify-content-around">
                                            <div className={`mx-2 CardCategory flex-center flex-column `}
                                                onClick={() => { setChooseCustomizeCategory(true); setchooseCategory(false) }}>
                                                <div className="icon-outside-new"><PersonalCardIcon /></div>
                                                <div className="myself">Customize</div>
                                            </div>
                                            {/* {(!cards.includes('Personal')) && (
                                            <div className={`mx-2 CardCategory flex-center flex-column ${NewCardType == 'Personal' ? 'selected' : ''}`}
                                                onClick={() => handleCardTypeClick('Personal')}>
                                                <div className="icon-outside-new"><ProfessionalIcon /></div>
                                                <div className="myself">Personal</div>
                                            </div>
                                        )} */}
                                            {(!cards.includes('Professional')) && (
                                                <div className={`mx-2 CardCategory flex-center flex-column ${NewCardType == 'Professional' ? 'selected' : ''}`}
                                                    onClick={() => handleCardTypeClick('Professional')}>
                                                    <div className="icon-outside-new"><ProfessionalIcon /></div>
                                                    <div className="myself">Professional</div>
                                                </div>
                                            )}
                                            {(!cards.includes('Student')) && (
                                                <div className={`mx-2 CardCategory flex-center flex-column ${NewCardType === 'Student' ? 'selected' : ''}`}
                                                    onClick={() => handleCardTypeClick('Student')}>
                                                    <div className="icon-outside-new"><StudentIcon /></div>
                                                    <div className="myself">Student</div>
                                                </div>
                                            )}
                                            {/* {(!cards.includes('GenZ')) && (
                                                <div className={`mx-2 CardCategory flex-center flex-column ${NewCardType === 'GenZ' ? 'selected' : ''}`}
                                                    onClick={() => handleCardTypeClick('GenZ')}>
                                                    <div className="icon-outside-new"><GenzIcon /></div>
                                                    <div className="myself">GenZ</div>
                                                </div>
                                            )} */}
                                        </div>
                                    </>
                                </div>
                            </div>
                        </>
                    </>
                }

                {chooseCustomizeCategory &&
                    <>
                        <div className="lightbox-overlay">
                            <div className="lightbox-content">
                                <>
                                    <div className='d-flex align-items-center justify-content-between'>
                                        <div className='d-flex align-items-center'>
                                            <IconButton onClick={() => { setchooseCategory(true); setChooseCustomizeCategory(false); }}>
                                                <ArrowBackIcon />
                                            </IconButton>
                                            <h6 className='heading-fav text-left mb-0 ms-1'>
                                                Choose Category for Customization</h6>
                                        </div>
                                        <IconButton onClick={handleCloseVerifiedDialog} sx={{ margin: 0, padding: 0 }}>
                                            <CloseRoundedIcon />
                                        </IconButton>
                                    </div>

                                    <div className="mt-2 selectedOptions d-flex align-items-center justify-content-around">
                                        {cards.includes("Personal") && (
                                            <div className={`mx-2 CardCategory flex-center flex-column ${NewCardType == 'Personal' ? 'selected' : ''}`}
                                                onClick={() => handleCardTypeClick('Customize_Personal')}>
                                                <div className="icon-outside-new"><PersonalCardIcon /></div>
                                                <div className="myself">Personal</div>
                                            </div>
                                        )}
                                        {cards.includes("Professional") && (
                                            <div className={`mx-2 CardCategory flex-center flex-column ${NewCardType == 'Customize_Professional' ? 'selected' : ''}`}
                                                onClick={() => handleCardTypeClick('Customize_Professional')}>
                                                <div className="icon-outside-new"><ProfessionalIcon /></div>
                                                <div className="myself">Professional</div>
                                            </div>
                                        )}
                                        {cards.includes("Student") && (
                                            <div className={`mx-2 CardCategory flex-center flex-column ${NewCardType === 'Customize_Student' ? 'selected' : ''}`}
                                                onClick={() => handleCardTypeClick('Customize_Student')}>
                                                <div className="icon-outside-new"><StudentIcon /></div>
                                                <div className="myself">Student</div>
                                            </div>
                                        )}
                                        {/* <div className={`mx-2 CardCategory flex-center flex-column ${NewCardType === 'Customize_GenZ' ? 'selected' : ''}`}
                                            onClick={() => handleCardTypeClick('Customize_GenZ')}>
                                            <div className="icon-outside-new"><GenzIcon /></div>
                                            <div className="myself">GenZ</div>
                                        </div> */}
                                    </div>
                                </>
                            </div>
                        </div>
                    </>
                }

                {chooseCategoryForGroup &&
                    <>
                        <>
                            <div className="lightbox-overlay">
                                <div className="lightbox-content">
                                    <>
                                        <div className='d-flex align-items-center justify-content-between'>
                                            <div className='d-flex align-items-center'>
                                                <IconButton onClick={() => { setChooseCategoryGroup(false); setOpenLightBoxForCategory(true); }}>
                                                    <ArrowBackIcon />
                                                </IconButton>
                                                <h6 className='heading-fav text-left mb-0 ms-1'>
                                                    Choose Category</h6>
                                            </div>
                                            {/* <button style={{ cursor: 'pointer' }} className="lightbox-close2" onClick={handleCloseVerifiedDialog}>×</button> */}
                                            <IconButton onClick={() => { setChooseCategoryGroup(false); }} sx={{ margin: 0, padding: 0 }}>
                                                <CloseRoundedIcon />
                                            </IconButton>
                                        </div>


                                        <div className="mt-2 selectedOptions d-flex justify-content-around">
                                            {/* {!filteredGroupCards && */}
                                            {(filteredGroupCards?.length === 0) && (
                                                <div
                                                    className={`mx-2 CardCategory flex-center flex-column`}
                                                    onClick={() => {
                                                        setChooseCategoryGroup(false);
                                                        setFamilyCardCreate(true);
                                                    }}
                                                >
                                                    <div className="icon-outside-new"><FamilyIcon /></div>
                                                    <div className="myself">Family</div>
                                                </div>
                                            )}

                                            {/* } */}
                                            {/* <div
                                            className={`mx-2 CardCategory flex-center flex-column ${selectedCategory === 'Family' ? 'selected' : ''}`}
                                            onClick={() => handleCategoryClick('Family')}
                                        > */}
                                            <div className="mx-2 CardCategory flex-center flex-column"
                                                onClick={() => { setChooseCategoryGroup(false); }}>
                                                <div className="icon-outside-new"><FriendsIcon /></div>
                                                <div className="myself">Friends</div>
                                            </div>

                                            <div className="mx-2 CardCategory flex-center flex-column">
                                                <div className="icon-outside-new"><PersonalCardIcon /></div>
                                                <div className="myself">Others</div>
                                            </div>
                                        </div>
                                    </>
                                </div>
                            </div>
                        </>
                    </>
                }
                <LightBoxGroupCreate setFamilyCardCreate={setFamilyCardCreate} familyCardCreate={familyCardCreate} />
            </div>
        </div >
    );
}

export default AllCards;